import { zipCodeSchema } from "@/components/Forms/schema/zipCodeSchema.ts";
import useAuthenticatedFetch from "@/hooks/useAuthenticatedFetch.ts";
import { apiUrl } from "@/utils/api.ts";
import { type UseQueryResult, useQuery } from "@tanstack/react-query";
import { createResourceCollectionSelector } from "jsonapi-zod-query";

const zipCodeTypeSelector = createResourceCollectionSelector({
    type: "zipCode",
    attributesSchema: zipCodeSchema,
});

export type ZipCode = ReturnType<typeof zipCodeTypeSelector>;

type Props = {
    zipCode: string | null;
    isQueryEnabled?: boolean;
};
export const useFetchZipCodes = ({
    isQueryEnabled = true,
    zipCode,
}: Props): UseQueryResult<ZipCode> => {
    const fetch = useAuthenticatedFetch();

    return useQuery({
        queryKey: ["zipCode", zipCode],
        enabled: isQueryEnabled,
        queryFn: async () => {
            const fetchURL = apiUrl(`/zipCode/${zipCode}`);

            const response = await fetch(fetchURL.href, {
                method: "GET",
                headers: {
                    "Content-Type": "application/vnd.api+json",
                },
            });

            return await response.json();
        },
        select: zipCodeTypeSelector,
    });
};
